export enum HEPLERS_ACTIONS_TYPES {
    TOGGLE_GRID_HEPLER = 'TOGGLE_GRID_HELPER',
    TOGGLE_POINTER_HELPER = 'TOGGLE_POINTER_HELPER',
    TOGGLE_SHAPE_HELPER = 'TOGGLE_SHAPE_HELPER'
};